<template>
  <el-container>
    <el-container>
      <el-header>
        <nav-header></nav-header>
      </el-header>
      <el-main>
        <div>
          <h1>
            如果您还不清楚什么是加特利模型，请自行网络搜索谐波加特利形态！本网站尚处于初始创建阶段，旨在通过提供加特利模型为投资提供参考。如有任何意见和建议，请通过<a
              href="mailto:gartleychina@163.com"
              >Email</a
            >联系我们。
          </h1>
        </div>
      </el-main>
      <el-header>
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">
          京ICP备2023037046号
        </a>
      </el-header>
    </el-container>
  </el-container>
</template>
<script>
import NavHeader from "@/components/NavHeader.vue";

export default {
  components: { NavHeader }
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue